// import React, { useEffect, useState } from "react";
// import "./AddCabServiceProvider.css";
// import TextInput from "../../Global Functions/textInput";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import SelectInput from "../../Global Functions/selectInput";
// import MainLayout from "../../Layout/mainLayout";
// import { useDispatch, useSelector } from "react-redux";
// import { viewCityList, viewCountryList, viewStateList } from "../../Redux/Actions/settingsActions";
// import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
// import AddImage from "../../Global Functions/addImage";
// import { addCabService } from "../../Redux/Actions/cabRequestActions";

// const AddCabServiceProvider = () => {
//   const dispatch = useDispatch();
//   useEffect(() => {
//     const countryData = {
//       page: 1,
//       limit: 250,
//     };
//     dispatch(viewCountryList(countryData))
//   }, [])
//   const navigate = useNavigate();
//   const { countryList } = useSelector((state) => state.country || {});
//   const { states } = useSelector((state) => state.states || {});
//   const { cities } = useSelector((state) => state.city || {});
//   const{addCabServiceResponse}= useSelector((state)=>state.cab || {});
//   console.log(addCabServiceResponse,"response")


//   const [formData, setFormData] = useState({
//     company_name: "",
//     country_id: "",
//     state: "",
//     city: "",
//     country_code: "",
//     contact_number: "",
//     address: "",
//     logo: null,
//   });

//   const handleChange = (e) => {
//     const { name, type, value, checked } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     console.log("Submitting", formData);
//     dispatch(addCabService(formData))
//     navigate("/cabServiceProvider")
//   };
//   useEffect(() => {
//     if (formData.country_id) {
//       dispatch(
//         viewStateList({
//           page: 1,
//           limit: 1000,
//           country: formData.country_id,
//         })
//       );
//     }
//   }, [formData.country_id, dispatch]);

//   useEffect(() => {
//     if (formData.state) {
//       dispatch(
//         viewCityList({
//           page: 1,
//           limit: 1000,
//           country: formData.country_id,
//           state: formData.state,
//         })
//       );
//     }
//   }, [formData.state, formData.country_id, dispatch]);

//   const handleImageUpload = async (e) => {
//     const uploadedFile = e.target.files[0];
//     if (!uploadedFile) return;
//     const responseUrl = await AddImage(uploadedFile);
//     if (responseUrl) {
//       setFormData((prev) => ({ ...prev, logo: responseUrl }));
//     }
//   };

//   console.log(formData,"formdataFInal")
//   return (
//     <MainLayout>
//       <div className="cab-form-wrapper">
//         <div className="cab-form-header">
//           <h2>Cab Service Provider</h2>
//           <button onClick={() => navigate("/view-service-providers")}>
//             View Service Provider
//           </button>
//         </div>
//         <form className="cab-form" onSubmit={handleSubmit}>
//           <div className="form-group">
//             <TextInput
//               label="Organisation Name"
//               placeholder="Enter Organisation Name"
//               name="company_name"
//               value={formData.company_name}
//               onChange={handleChange}
//             />
//           </div>

//           <div className="form-group">
//             <SelectInput
//               label="Select Country"
//               placeholder="Select Country"
//               name="country_id"
//               value={formData.country_id}
//               onChange={handleChange}
//               options={countryList?.data?.map((c) => ({
//                 label: c.country_name,
//                 value: c._id,
//               })) || []}
//             />
//           </div>

//           <div className="form-group">
//             <SelectInput
//               label="Select State"
//               name="state"
//               value={formData.state}
//               onChange={handleChange}
//               disabled={!formData.country_id}
//               options={states?.data?.map((s) => ({
//                 label: s.state_name,
//                 value: s._id,
//               })) || []}
//             />
//           </div>

//           <div className="form-group">
//             <SelectInput
//               label="Select City"
//               name="city"
//               value={formData.city}
//               onChange={handleChange}
//               disabled={!formData.state}
//               options={cities?.data?.map((c) => ({
//                 label: c.city_name,
//                 value: c._id,
//               })) || []}
//             />
//           </div>

//           <div className="form-group">
//             <SelectInput
//               label="Country Code"
//               name="country_code"
//               value={formData.country_code}
//               onChange={handleChange}
//               options={countryList?.data?.map((c) => ({
//                 label: c.country_name,
//                 value: c.country_phone_code,
//               })) || []}
//             />
//           </div>

//           <div className="form-group">
//             <TextInput
//               label="Enter Phone Number"
//               placeholder="Enter Phone Number"
//               name="contact_number"
//               value={formData.contact_number}
//               onChange={handleChange}
//             />
//           </div>

//           <div className="form-group">
//             <TextInput
//               label="Address"
//               placeholder="Enter Address"
//               name="address"
//               value={formData.address}
//               onChange={handleChange}
//             />
//           </div>

//           <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
//             <div style={{ width: "100%" }}>
//               <span className="span-class">Upload  Image</span>
//               <input type="file" name="logo" id="logo" onChange={handleImageUpload} hidden />
//               <label className="label-class-image" htmlFor="logo">
//                 Click To Upload Image
//               </label>
//               <ImageShowerModalGlobal
//                 file={formData.logo}
//                 keyField="logo"
//                 setState={setFormData}
//                 state={formData}
//               />
//             </div>
//           </div>

//           <div className="form-footer">
//             <button type="button" onClick={() => navigate(-1)}>Cancel</button>
//             <button type="submit">Save</button>
//           </div>
//         </form>
//       </div>
//     </MainLayout>
//   );
// };

// export default AddCabServiceProvider;

import React, { useEffect, useState } from "react";
import "./AddCabServiceProvider.css";
import TextInput from "../../Global Functions/textInput";
import SelectInput from "../../Global Functions/selectInput";
import MainLayout from "../../Layout/mainLayout";
import { useDispatch, useSelector } from "react-redux";
import { viewCityList, viewCountryList, viewStateList } from "../../Redux/Actions/settingsActions";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";
import AddImage from "../../Global Functions/addImage";
import { addCabService } from "../../Redux/Actions/cabRequestActions";
import { useNavigate } from "react-router-dom";

const AddCabServiceProvider = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { countryList } = useSelector((state) => state.country || {});
  const { states } = useSelector((state) => state.states || {});
  const { cities } = useSelector((state) => state.city || {});

  const [formData, setFormData] = useState({
    company_name: "",
    country: "",
    country_name: "",
    country_code: "",
    state: "",
    city: "",
    contact_number: "",
    address: "",
    logo: null,
  });

  // Fetch countries on mount
  useEffect(() => {
    dispatch(viewCountryList({ page: 1, limit: 250 }));
  }, [dispatch]);

  // Fetch states when country changes
  useEffect(() => {
    if (formData.country) {
      dispatch(viewStateList({ page: 1, limit: 1000, country: formData.country }));
      setFormData((prev) => ({ ...prev, state: "", city: "" })); // reset state and city
    }
  }, [formData.country, dispatch]);

  // Fetch cities when state changes
  useEffect(() => {
    if (formData.state) {
      dispatch(viewCityList({ page: 1, limit: 1000, country: formData.country, state: formData.state }));
      setFormData((prev) => ({ ...prev, city: "" })); // reset city
    }
  }, [formData.state, formData.country, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "country") {
      const selectedCountry = countryList?.data?.find((c) => c._id === value);
      setFormData((prev) => ({
        ...prev,
        country: value,
        country_name: selectedCountry?.country_name || "",
        country_code: selectedCountry?.country_phone_code || "",
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleImageUpload = async (e) => {
    const uploadedFile = e.target.files[0];
    if (!uploadedFile) return;

    const responseUrl = await AddImage(uploadedFile);
    if (responseUrl) {
      setFormData((prev) => ({ ...prev, logo: responseUrl }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(addCabService(formData));
    navigate("/cabServiceProvider");
  };

  return (
    <MainLayout>
      <div className="cab-form-wrapper">
        <div className="cab-form-header">
          <h2>Cab Service Provider</h2>
          <button onClick={() => navigate("/view-service-providers")}>View Service Provider</button>
        </div>

        <form className="cab-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <TextInput
              label="Organisation Name"
              placeholder="Enter Organisation Name"
              name="company_name"
              value={formData.company_name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <SelectInput
              label="Select Country"
              placeholder="Select Country"
              name="country"
              value={formData.country}
              onChange={handleChange}
              options={countryList?.data?.map((c) => ({ label: c.country_name, value: c._id })) || []}
            />
          </div>

          <div className="form-group">
            <SelectInput
              label="Select State"
              placeholder="Select State"
              name="state"
              value={formData.state}
              onChange={handleChange}
              disabled={!formData.country}
              options={states?.data?.map((s) => ({ label: s.state_name, value: s._id })) || []}
            />
          </div>

          <div className="form-group">
            <SelectInput
              label="Select City"
              placeholder="Select City"
              name="city"
              value={formData.city}
              onChange={handleChange}
              disabled={!formData.state}
              options={cities?.data?.map((c) => ({ label: c.city_name, value: c._id })) || []}
            />
          </div>

          <div className="form-group">
            <TextInput
              label="Country Code"
              name="country_code"
              value={formData.country_code}
              onChange={handleChange}
              disabled
            />
          </div>

          <div className="form-group">
            <TextInput
              label="Enter Phone Number"
              placeholder="Enter Phone Number"
              name="contact_number"
              value={formData.contact_number}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <TextInput
              label="Address"
              placeholder="Enter Address"
              name="address"
              value={formData.address}
              onChange={handleChange}
            />
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
            <div style={{ width: "100%" }}>
              <span className="span-class">Upload Image</span>
              <input type="file" name="logo" id="logo" onChange={handleImageUpload} hidden />
              <label className="label-class-image" htmlFor="logo">
                Click To Upload Image
              </label>
              <ImageShowerModalGlobal file={formData.logo} keyField="logo" setState={setFormData} state={formData} />
            </div>
          </div>

          <div className="form-footer">
            <button type="button" onClick={() => navigate(-1)}>Cancel</button>
            <button type="submit">Save</button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddCabServiceProvider;
